import {
  AfterContentInit,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  input,
} from '@angular/core';
import { ServiceCategoryModel } from '@app/src/app/modules/service/classes/category/model/service.category.model';
import { SolutionCategoryModel } from '@app/src/app/modules/solution/classes/category/model/solution.category.model';
import { ContentFlex, Translation } from '@ckmk/angular';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'front-footer',
  standalone: true,
  imports: [Translation, RouterLink, RouterLinkActive, ContentFlex],
  templateUrl: './front-footer.html',
  styleUrl: './front-footer.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FrontFooter
  implements OnInit, OnChanges, OnDestroy, AfterContentInit
{
  public readonly serviceCategories = input.required<ServiceCategoryModel[]>();

  public readonly solutionCategories =
    input.required<SolutionCategoryModel[]>();

  public constructor() {}

  public ngOnInit() {}

  public ngOnChanges(changes: SimpleChanges) {}

  public ngOnDestroy() {}

  public ngAfterContentInit() {}
}
